import { Input, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { RawInformationProps } from './raw-information.type'

import styles from './raw-information.module.css'

export const RawInformation = ({
  onSetRawInformation,
  rawInformation,
}: RawInformationProps) => {
  const { t } = useTranslation('screenQuotationRequestListV2')

  return (
    <div className={styles.core}>
      <Text>{t('rawInformationDescription')}</Text>

      <Input isTextArea value={rawInformation} onChange={onSetRawInformation} />
    </div>
  )
}
